import GoogleMapsLoader from 'google-maps';
import {mapGetters} from 'vuex';
import {configTables} from "../../../global/configTables.js";
import {api} from "../../../global/framework/api.js";
import {formatter} from "../../../global/formatter.js";
import _ from "lodash";

export const searchBoxMixin = {
	props: {radiusId: {type: [Number], required: true}},
	data() {
		return {
			widgetReady: false,
			//Note: this will bind to the NEW search criteria, store will contain the CURRENT one
			searchCriteria: {
				radiusId: this.radiusId,
				addressId: 0,
				zipCode: '',
				latitude: 0,
				longitude: 0,
				designationId: null,
				onlyAcceptingNewPatients: false,
				physicianName: "",
				addressName: "",
				networkId: null,
				planCategoryId: null
			},
			searchRadiusOptions: [],
			professionalDesignations: [],
			availableNetworks: [],
			autocomplete: null,
			hasSearchCriteria: false
		};
	},
	computed: {
		...mapGetters(["searchResults", "distance"]),
		...mapGetters({showInOfficePlans: 'globalSettings/showInOfficePlans', showVirtualPlans: 'globalSettings/showVirtualPlans'}),
	},
	methods: {
		async baseInit() {
			this.baseLoad();
			//Initialize search criteria with properties from the url, if they are not set we will just go with the defaults
			await this.setCurrentCriteria();
			//console.log("distance", this.distance);
			this.createAddressAutocomplete();
			if (this.hasSearchCriteria) {
				//console.log("Initializing search box mixin, criteria:", this.searchCriteria);
				await this.$store.dispatch("SEARCH_PHYSICIANS", {
					searchCriteria: this.searchCriteria,
					baseUrl: this.generateBaseUrl()
				});
			}
		},
		searchPhysiciansRedirect() {
			throw new Error("physician search redirect needs to be overwritten by child");
		},
		generateBaseUrl() {
			throw new Error("generate base url needs to be overwritten by child");
		},
		async setCurrentCriteria() {
			//Read parameters from url if any
			this.searchCriteria.physicianName = this.$route.query.physicianName || '';
			this.searchCriteria.addressId = Boolean(this.$route.params.addressId) ? Number(this.$route.params.addressId) : 0;
			if (this.searchCriteria.addressId) {
				let addressView = await api.get('Address', this.searchCriteria.addressId, 'GetView');
				this.searchCriteria.addressName = formatter.formatAddress(addressView.address1,
					addressView.address2,
					addressView.city,
					addressView.stateCode,
					addressView.zipCode);
				this.searchCriteria.latitude = addressView.latitude;
				this.searchCriteria.longitude = addressView.longitude;
				this.hasSearchCriteria = true;
			} else if (Boolean(this.$route.params.latitude) && Boolean(this.$route.params.longitude)) {
				this.searchCriteria.addressName = this.$route.query.addressName || '';
				this.searchCriteria.latitude = this.$route.params.latitude;
				this.searchCriteria.longitude = this.$route.params.longitude;
				this.hasSearchCriteria = true;
			}
			if (!this.searchCriteria.radiusId) {
				if (this.showVirtualPlans) {
					this.searchCriteria.radiusId = 7;//Default value for virtual plans: Unlimited
				} else {
					this.searchCriteria.radiusId = 4;//Default value for in-office plans
				}
			}
			this.searchCriteria.designationId = this.$route.query.designationId || null;
			this.searchCriteria.onlyAcceptingNewPatients = Boolean(Number(this.$route.query.onlyAcceptingNewPatients | "0"));
			this.searchCriteria.planCategoryId = this.$route.query.planCategoryId;
			this.searchCriteria.networkId = this.$route.query.networkId || null;
		},
		createAddressAutocomplete() {
			GoogleMapsLoader.KEY = 'AIzaSyBULgN2oWltDQFqUfdnoAFSg76UcLTbvvM';
			GoogleMapsLoader.LIBRARIES = ['places'];
			GoogleMapsLoader.VERSION = '';
			let self = this;
			GoogleMapsLoader.load(function (google) {
				self.widgetReady = true;
				self.$nextTick(function () {
					//console.log('self.$refs:', self.$refs, 'autocomplete:', self.$refs.autocompleteRef);
					self.autocomplete = new google.maps.places.Autocomplete(
						self.$refs.autocompleteRef,
						{types: ['geocode']}
					);
					self.autocomplete.addListener('place_changed', self.autocompleteCallback);
					$(self.$refs.autocompleteRef).val(self.searchCriteria.addressName || '');
				});
			});
		},
		autocompleteCallback() {
			let place = this.autocomplete.getPlace();
			this.searchCriteria.latitude = place.geometry.location.lat();
			this.searchCriteria.longitude = place.geometry.location.lng();
			this.searchCriteria.addressName = $(this.$refs.autocompleteRef).val();
		},
		async baseLoad() {
			let [radius, designations] = await Promise.all([configTables.getSearchRadiusOptions(),
				configTables.getProfessionalDesignations()
			]);
			this.searchRadiusOptions = radius;
			this.professionalDesignations = designations;
		},
		openFaqModal() {
			this.$refs.faqModal.showModal();
		}
	}
};